import { render, staticRenderFns } from "./newSnailLive.vue?vue&type=template&id=42247932&scoped=true&"
import script from "./newSnailLive.vue?vue&type=script&lang=js&"
export * from "./newSnailLive.vue?vue&type=script&lang=js&"
import style0 from "./newSnailLive.vue?vue&type=style&index=0&id=42247932&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42247932",
  null
  
)

export default component.exports